/**
 * SaaS configuration helper to check if a specific module is active for a condominium
 */
export const isModuleEnabled = (condoData, moduleKey) => {
  // If no condominium data, default to true to prevent breaking during loading
  if (!condoData) return true;

  // Standardize the key by removing leading slash if present
  const cleanKey = moduleKey.startsWith('/') ? moduleKey.substring(1) : moduleKey;

  // Check if explicitly disabled in condominium settings
  if (Array.isArray(condoData.modulosDesactivados) && condoData.modulosDesactivados.includes(cleanKey)) {
    return false;
  }
  
  // If modulosActivos is not defined (legacy condos), try to compute it on the fly from saas_addons
  let activeModules = condoData.modulosActivos;
  if (!activeModules && condoData.saas_addons) {
    const list = ['core'];
    if (condoData.saas_addons.includes('saas_invoice_cfdi')) list.push('facturacion');
    if (condoData.saas_addons.includes('saas_hr_payroll')) list.push('nomina');
    if (condoData.saas_addons.includes('saas_bank_recon')) list.push('conciliacion');
    if (condoData.saas_addons.includes('saas_security_rounds')) list.push('seguridad');
    if (condoData.saas_addons.includes('saas_bidding_projects')) list.push('licitaciones');
    if (condoData.saas_addons.includes('saas_violations_fines')) list.push('sanciones');
    
    // Check custom IDs or name-based configurations from catalog
    condoData.saas_addons.forEach(id => {
      const lowerId = id.toLowerCase();
      if (lowerId.includes('estacionamiento')) list.push('estacionamientos');
      if (lowerId.includes('locker') || lowerId.includes('paquet') || lowerId.includes('smart_lockers')) list.push('paqueteria');
      if (lowerId.includes('hardware') || lowerId.includes('iot')) list.push('hardware_iot');
    });
    activeModules = list;
  }

  if (!activeModules) return true;
  
  // Mapping of route/module key to the required SaaS service/add-on ID
  const mapping = {
    // Core modules (always active if 'core' is active)
    'muro': 'core',
    'marketplace': 'core',
    'mis-reportes': 'core',
    'pagar-cuota': 'core',
    'encuestas': 'core',
    'vehiculos': 'core',
    'documentos': 'core',
    'gestion-usuarios': 'core',
    'gestion-amenidades': 'core',
    'configuracion-condominio': 'core',
    'gestion-avisos': 'core',
    'admin/encuestas': 'core',
    'admin/muro': 'core',
    'gestion-reportes': 'core',
    'gestion-vehiculos': 'core',
    'gestion-cuotas': 'core',
    'bitacora': 'core',
    'mis-accesos': 'core',
    'accesos': 'core',
    
    // Add-on modules
    'estacionamientos': 'estacionamientos',
    'gestion-finanzas': 'core', // General reports dashboard is core
    'finanzas/banco': 'core',
    'focus-facturas': 'core',
    'gestion-facturas': 'core',
    'nominas-dashboard': 'nomina',
    'seguridad': 'seguridad',
    'licitaciones': 'licitaciones',
    'apercibimientos': 'sanciones',
    'paqueteria': 'paqueteria',
    'admin/accesos': 'hardware_iot',
  };

  // Standardize the key by removing leading slash if present (already computed as cleanKey)
  const requiredService = mapping[cleanKey];
  if (!requiredService) return true; // Default to true for unmapped paths

  return activeModules.includes(requiredService);
};
